import * as React from 'react';

import {
  Container,
  Divider,
  Grid,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';

import Contacts from './Contacts';
import loc from '../../utils/loc';

const Footer = () => {
  // Trigger auto-refresh on locale state change.
  useSelector((state) => state.locale.value)

  return (
    <>
      <Divider sx={{ mt: 10 }} />
      <Container maxWidth="lg" sx={{ py: 2.5 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} sx={{ display: "flex" }}>
            <Typography variant="body3" component="div" sx={{ m: "auto" }}>{loc("footerMessage")}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Contacts color="grey" />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Footer;
